import React, { FC } from 'react'
import { mainColors } from '../../../assets/colors'
import LocationApplicationItem from '../../../types/LocationApplicationItem'

interface Props {
  cellContent: string;
  row: LocationApplicationItem;
}

const getStatusAndColor = (status: string) => {
  let statusTitle = ''
  let statusColor = ''
  switch (status) {
    case 'REJECTED':
      statusTitle = 'FEEDBACK PROVIDED'
      statusColor = mainColors.feedbackRed
      break
    case 'SUBMITTED':
      statusTitle = 'PENDING'
      statusColor = mainColors.ratingYellow
      break
    case 'APPROVED':
      statusTitle = status
      statusColor = mainColors.successGreen
      break
    default:
      statusTitle = status
      statusColor = mainColors.warningBlue
      break
  }

  return { title: statusTitle, backgroundColor: statusColor }
}

const Status: FC<Props> = ({ cellContent, row }: Props) => {
  const status = getStatusAndColor(cellContent)
  const width = cellContent === 'REJECTED' ? 200 : 150
  return (
    <span style={{ display: 'inline-block', backgroundColor: status.backgroundColor, color: 'white', width, textAlign: 'center', marginTop: 5 }}>
      {status.title}
    </span>
  )
}

export default Status 